<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChevronRight_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M5.251 12.756a.816.816 0 0 1 0-1.179L8.931 8 5.25 4.423a.816.816 0 0 1 0-1.179.873.873 0 0 1 1.212 0l4.286 4.167a.816.816 0 0 1 0 1.178l-4.286 4.167a.873.873 0 0 1-1.212 0"
    />
</svg>
